import { ContactSlugEnum, CountryEnum } from '@systemeio/ui'
import {
  ContactFilterTagConditionEnum,
  ContactSearchFieldEnum,
} from 'modules/contacts/enums/contact-enum'
import {
  ContactFilterConditionInterface,
  ContactFilterTextInterface,
  ContactFilterType,
  ContactFilterValueType,
} from 'modules/contacts/types/contact-filter-interface'

export const setFilterValue = (
  slug: string,
  value: ContactFilterConditionInterface,
): ContactFilterValueType => {
  switch (slug) {
    case ContactSlugEnum.Country: {
      return value.searchValue as CountryEnum
    }
    case ContactSearchFieldEnum.last_activity_date:
    case ContactSearchFieldEnum.affiliate: {
      return { searchValue: value.searchValue }
    }
    case ContactSearchFieldEnum.state: {
      return {
        searchValue: value.searchValue,
      }
    }
    case ContactSearchFieldEnum.tag: {
      return {
        compareOperation: value.compareOperation as ContactFilterTagConditionEnum,
        searchValue: value.searchValue ?? undefined,
      }
    }

    default: {
      return {
        searchValue: value.searchValue || undefined,
        compareOperation: value.compareOperation,
      } as ContactFilterTextInterface
    }
  }
}

export const setFilterFieldValue = ({
  filter,
  value,
  slug,
}: {
  filter: ContactFilterType
  slug: string
  value: ContactFilterConditionInterface
}) => {
  if (filter[slug]) {
    filter[slug] = [...filter[slug], setFilterValue(slug, value)]
  } else {
    filter[slug] = [setFilterValue(slug, value)]
  }
  return filter
}
